import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { ReactNode } from "react";
import { SheetDetent } from "react-modal-sheet";

import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

import { Modal } from "./modal";

type Props = {
    modalType: ModalType;
    discriminator?: string;
    className?: string;
    sheetDetent?: SheetDetent;
    title: string | ReactNode;
    subtitle?: string | ReactNode;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    confirmButtonText?: string;
    confirmButtonColor?: ButtonComponentProps["color"];
    cancelButtonText?: string;
    closable?: boolean;
    formId?: string;
    isLoading?: boolean;
    isConfirmDisabled?: boolean;
    withFooter?: boolean;
    centered?: boolean;
    autoFocus?: boolean;
    scrollable?: boolean;
    onConfirm?: () => void;
    onCancel?: () => void;
    onOpenEnd?: () => void;
    onCloseEnd?: () => void;
    children?: ReactNode;
};

export const RouterModal = ({
    modalType,
    discriminator,
    children,
    ...modalProps
}: Props) => {
    const { isOpen, isActive, toggle } = useModalRouter(
        modalType,
        discriminator
    );

    return (
        <Modal
            {...modalProps}
            modalType={modalType}
            discriminator={discriminator}
            open={isOpen}
            active={isActive}
            setOpen={toggle}
        >
            {children}
        </Modal>
    );
};
